/** A saved choice overrides the level default; automatic defaults stay unsaved. */
export function resolveExamplesBeforePractice(
  preference: unknown,
  languageLevel: unknown
): boolean {
  if (typeof preference === "boolean") return preference;
  if (typeof preference === "string") {
    const value = preference.trim().toLowerCase();
    if (value === "true") return true;
    if (value === "false") return false;
  }
  const level =
    typeof languageLevel === "string" && languageLevel.trim()
      ? languageLevel.trim().toLowerCase().replaceAll("-", "_")
      : "beginner";
  return ["absolute_beginner", "beginner", "a0", "pre_a1", "a1", "a2", "a1_a2"].includes(level);
}
